/**
 * AJAX Pagination with Slide Transitions
 * For Shopify Dawn Theme - Product Grid Section
 */

class AjaxPagination {
  constructor() {
    this.productGrid = document.querySelector('.collection');
    this.paginationContainer = document.querySelector('.pagination-wrapper');
    
    if (!this.productGrid || !this.paginationContainer) return;
    
    this.init();
  }

  init() {
    // Add click listeners to all pagination links
    this.addPaginationListeners();
    
    // Add CSS for animations
    this.injectStyles();
  }

  addPaginationListeners() {
    const paginationLinks = this.paginationContainer.querySelectorAll('a');
    
    paginationLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const url = link.getAttribute('href');
        this.loadPage(url);
      });
    });
  }

  async loadPage(url) {
    // Add loading state
    this.productGrid.classList.add('loading');
    
    // Slide out current content
    this.slideOut();
    
    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract new content
      const newProductGrid = doc.querySelector('.collection');
      const newPagination = doc.querySelector('.pagination-wrapper');
      
      // Wait for slide out animation to complete
      await this.wait(400);
      
      // Replace content
      if (newProductGrid) {
        this.productGrid.innerHTML = newProductGrid.innerHTML;
      }
      
      if (newPagination) {
        this.paginationContainer.innerHTML = newPagination.innerHTML;
      }
      
      // Slide in new content
      this.slideIn();
      
      // Re-attach listeners to new pagination links
      this.addPaginationListeners();
      
      // Update browser URL
      window.history.pushState({}, '', url);
      
      // Scroll to top of product grid
      this.scrollToGrid();
      
      // Remove loading state
      this.productGrid.classList.remove('loading');
      
    } catch (error) {
      console.error('Error loading page:', error);
      // Fallback to normal page load
      window.location.href = url;
    }
  }

  slideOut() {
    this.productGrid.style.transition = 'transform 0.4s ease-in-out, opacity 0.4s ease-in-out';
    this.productGrid.style.transform = 'translateX(-100%)';
    this.productGrid.style.opacity = '0';
  }

  slideIn() {
    // Start from right side
    this.productGrid.style.transition = 'none';
    this.productGrid.style.transform = 'translateX(100%)';
    this.productGrid.style.opacity = '0';
    
    // Force reflow
    this.productGrid.offsetHeight;
    
    // Animate in
    this.productGrid.style.transition = 'transform 0.4s ease-in-out, opacity 0.4s ease-in-out';
    this.productGrid.style.transform = 'translateX(0)';
    this.productGrid.style.opacity = '1';
  }

  scrollToGrid() {
    const gridTop = this.productGrid.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({
      top: gridTop,
      behavior: 'smooth'
    });
  }

  wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .collection {
        position: relative;
        overflow: hidden;
      }
      
      .collection.loading {
        pointer-events: none;
      }
      
      .pagination-wrapper {
        transition: opacity 0.3s ease;
      }
      
      .collection.loading ~ .pagination-wrapper {
        opacity: 0.5;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AjaxPagination();
  });
} else {
  new AjaxPagination();
}